import * as React from "react";

import "./order-usage-history.scss";

import {cs}          from "@Common/react/chain-services";
import {DataTableD1} from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {PageList}    from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {formatMoney} from "@Common/ui-components/language/format-money";

import {formatDate} from "../common/format-date";

export const OrderUsageHistory = ({voucher}) => cs(
    () => (
        <div className="order-usage-history order-usage-history-3i4">
            {DataTableD1({
                pageSize: 10,
                rows: voucher?.usage?.map((u) => ({
                    columns: [
                        {
                            render: () => u.idOrder,
                            sortValue: () => u.idOrder,
                            domAttrs: {
                                "xd-qa-type": "text",
                                "xd-qa-name": "Order ID"
                            }
                        },
                        {
                            render: () => u.dateCreated && formatDate(u.dateCreated),
                            sortValue: () => new Date(u.dateCreated).getTime(),
                            domAttrs: {
                                "xd-qa-type": "text",
                                "xd-qa-name": "Date"
                            }
                        },
                        {
                            render: () => formatMoney(u.used),
                            sortValue: () => +u.used,
                            domAttrs: {
                                "xd-qa-type": "text",
                                "xd-qa-name": "Amount Applied"
                            }
                        },
                    ],
                })),
                columns,
                getFooter: ({colCount, pagination}) => ({
                    columns: [{
                        colSpan: colCount,
                        render: () => (
                            pagination.active && PageList({
                                ...pagination,
                            })
                        )
                    }],
                }),
            })}
        </div>
    ),
);

const columns = [
    {
        label: "ORDER",
        className: "order",
        sortable: {
            defaultDirection: "asc",
        },
        width: "20%",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "ORDER",
        },
    },
    {
        label: "DATE",
        className: "date",
        sortable: {
            defaultDirection: "desc",
        },
        width: "20%",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "DATE",
        },
    },
    {
        label: "AMOUNT APPLIED",
        className: "amount-applied",
        sortable: {
            defaultDirection: "desc",
        },
        width: "80%",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "AMOUNT APPLIED",
        },
    },
];
